/**
 * D-ENTRY-DIAET1 — die Schluesselbasen der Praeferenz-Registry als Blatt.
 *
 * SINGLE SOURCE der localStorage-Schluesselbasen. `registry.ts` leitet seine
 * `cleanupBase`-Eintraege von hier ab und bleibt die Quelle der Registry;
 * `lib/tenantScopedStorage.ts` (und damit Session-Start und Logout-Bereinigung)
 * importiert NUR dieses Modul. So zieht der Entry-Chunk nicht die ganze
 * Registry mit (Decoder, Metadaten, Hook-Adapter).
 *
 * Dieses Modul hat KEINE Laufzeit-Imports. Jede Aenderung hier wird vom
 * Source-Guard in `preferences.source-guards.test.ts` gegen die Registry
 * geprueft.
 */

// ── managed preferences (engine-driven, identity-scoped) ─────────────────
export const TRIPS_FILTERS_CLEANUP_BASE = "gt.trips.filters.v2";
export const SAVED_FILTERS_CLEANUP_BASE = "gt:wave-j:filters:";
export const TABLE_COLUMNS_CLEANUP_BASE = "gt:wave-j:columns:";
export const LIVE_MAP_FILTERS_CLEANUP_BASE = "gt:wave-j:map-filters";
export const REPORTS_COLUMNS_CLEANUP_BASE = "gt:wave-j:reports-columns:";
export const FEEDBACK_DRAFT_CLEANUP_BASE = "gt:wave-j:feedback-draft";
export const MODULE_NOTICE_CLEANUP_BASE = "gt:wave-j:module-notice:";

// ── external preferences (browser-GLOBAL, never purged) ──────────────────
export const LOCALE_PREFERENCE_KEY = "gt.locale";
export const THEME_PREFERENCE_KEY = "gt.theme";

/**
 * Physische Schluessel der browser-GLOBALEN externen Praeferenzen. Sie sind
 * NIE identitaetsgebunden und ueberleben Logout / Identitaetswechsel. Der
 * Cross-Identity-Cleanup behandelt sie als geschuetzt und entfernt sie nie
 * (sie stehen nicht in PREFERENCE_KEY_BASES). Siehe
 * `tenantScopedStorage.purgeLegacyUnscopedState`.
 */
export const EXTERNAL_PREFERENCE_KEYS: readonly string[] = [
  LOCALE_PREFERENCE_KEY,
  THEME_PREFERENCE_KEY,
];

// ── legacy cleanup-only bases (purged but not yet engine-managed) ────────
export const LEGACY_CLEANUP_BASES: readonly string[] = [
  // GT-SMOKE-ROUND3 (S7) — der v1 Trips-Filterschluessel (nur Fahrzeug-IDs).
  "gt.trips.filter.vehicleIds.v1",
  "gt-reports-columns-v1-",
  "gt.sprint26.feedback.lastBody",
];

/**
 * Lane B GT-USER-PREFERENCES-SERVER-SYNC-01 — Praefix des abgeleiteten
 * First-Paint-Caches fuer serverseitig synchronisierte Praeferenzen.
 */
export const SERVER_CACHE_CLEANUP_BASE = "gt:server-cache:v1:";

/**
 * Jede localStorage-Schluesselbasis, die der Cleanup-Sweep als
 * mandantenbezogen behandelt. Die Reihenfolge entspricht der Registry
 * (managed, legacy, server cache).
 */
export const PREFERENCE_KEY_BASES: readonly string[] = [
  TRIPS_FILTERS_CLEANUP_BASE,
  SAVED_FILTERS_CLEANUP_BASE,
  TABLE_COLUMNS_CLEANUP_BASE,
  LIVE_MAP_FILTERS_CLEANUP_BASE,
  REPORTS_COLUMNS_CLEANUP_BASE,
  FEEDBACK_DRAFT_CLEANUP_BASE,
  MODULE_NOTICE_CLEANUP_BASE,
  ...LEGACY_CLEANUP_BASES,
  SERVER_CACHE_CLEANUP_BASE,
];
